import { AnalyticsEventParams, AnalyticsPageViewParams } from "@/lib/models/analytics";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
    dataLayer?: unknown[];
  }
}

export function trackPageView({ path, title, location }: AnalyticsPageViewParams): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  try {
    window.gtag("event", "page_view", {
      page_path: path,
      page_title: title || document.title,
      page_location: location || window.location.href,
    });
  } catch (error) {
    console.error("Error al registrar vista de página en Google Analytics:", error);
  }
}

export function trackEvent({
  category,
  action,
  label,
  value,
  ...rest
}: AnalyticsEventParams): void {
  if (typeof window === "undefined" || typeof window.gtag !== "function") {
    return;
  }

  try {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value: value,
      ...rest,
    });
  } catch (error) {
    console.error("Error al enviar evento a Google Analytics:", error);
  }
}
